"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 *
 * @preferred
 */
var service_1 = require("../service");
var Currencies;
(function (Currencies) {
    function getAvailableCurrencies() {
        var service = new service_1.EVAService("GetAvailableCurrencies");
        return new Promise(function (resolve, reject) {
            // Perform the call and capture the resulting promise
            //
            service.call().then(function (serviceResult) {
                var currencies = serviceResult.response.Currencies;
                resolve(currencies);
            })
                .catch(function (error) {
                reject(error);
            });
        });
    }
    Currencies.getAvailableCurrencies = getAvailableCurrencies;
    function setOrderCurrency(currencyID, orderID) {
        var service = new service_1.EVAService("UpdateOrderCurrency");
        var requestData = {
            OrderID: orderID,
            CurrencyID: currencyID,
            SessionID: null,
        };
        return new Promise(function (resolve, reject) {
            // Perform the call and capture the resulting promise
            //
            service.call(requestData).then(function (serviceResult) {
                resolve(serviceResult);
            })
                .catch(function (error) {
                reject(error);
            });
        });
    }
    Currencies.setOrderCurrency = setOrderCurrency;
})(Currencies = exports.Currencies || (exports.Currencies = {}));
